module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.12-243.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.12.md
// module id = 686
// module chunks = 282